import { render } from "./QRLabel.vue?vue&type=template&id=0a1914f6"
import script from "./QRLabel.vue?vue&type=script&lang=js"
export * from "./QRLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__